import { ButtonBase, Typography } from "@mui/material"
import type { FC } from "react"

import type { Invoice } from "@/graphql/codegen/graphql"

interface DuplicateRowProps {
  invoice: Invoice
  index: number
  onReview: (invoiceId: string) => void
}

export const DuplicateRow: FC<DuplicateRowProps> = ({ invoice, index, onReview }) => {
  const handleRowClick = () => {
    onReview(invoice.invoiceId)
  }

  return (
    <ButtonBase
      onClick={handleRowClick}
      data-testid={`invoice.duplicate-warning-dialog.row-${invoice.invoiceId}`}
      className='self-center px-2 py-1'
    >
      <Typography className='text-base font-medium text-primary hover:underline'>
        Review Matching Invoice {index + 1}
      </Typography>
    </ButtonBase>
  )
}
